import Icon from '../components/Icon.vue'

Icon.register({
  'volume-mute': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M215 71.1c15-15 41-4.5 41 17v336c0 21.4-25.9 32-41 17l-89-89h-102.1c-13.3 0-24-10.8-24-24v-144c0-13.3 10.7-24 24-24h102.1zM461.6 256l45.6 45.6c6.3 6.3 6.3 16.5 0 22.8l-22.8 22.8c-6.3 6.3-16.5 6.3-22.8 0l-45.6-45.6-45.6 45.6c-6.3 6.3-16.5 6.3-22.8 0l-22.8-22.8c-6.3-6.3-6.3-16.5 0-22.8l45.6-45.6-45.6-45.6c-6.3-6.3-6.3-16.5 0-22.8l22.8-22.8c6.3-6.3 16.5-6.3 22.8 0l45.6 45.6 45.6-45.6c6.3-6.3 16.5-6.3 22.8 0l22.8 22.8c6.3 6.3 6.3 16.5 0 22.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/volume-mute.js
// module id = 2094
// module chunks = 0